module.exports = "<h1>Found in {{ $ctrl.name }}.html</h1>\n\n<div>\n\t<md-input-container>\n\t    <label>CPF</label>\n\t    <input type=\"text\" name=\"field\" ng-model=\"initializedCpf\" ui-br-cpf-mask>\n\t</md-input-container>\n</div>\n\n<div flex-gt-xs>\n\t<h4>Standard date-picker</h4>\n\n\t<md-datepicker ng-model=\"myDate\" md-placeholder=\"Enter date\"></md-datepicker>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/home/home.html
// module id = 521
// module chunks = 0